import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  theme: BehaviorSubject<string> = new BehaviorSubject("LIGHT");
  constructor(@Inject(DOCUMENT) private document: Document) {
    // Default theme is Light mode
    const theme: string = localStorage.getItem("currentTheme") || "LIGHT";
    this.theme.next(theme);
    const element = document.querySelector("html");
    if (element && theme === "DARK") {
      element.classList.toggle("dark");
    }

    this.setCssTheme(theme);
  }

  setCssTheme(theme: string) {
    localStorage.setItem("currentTheme", theme);
    this.theme.next(theme);
  }
}
